module.exports = __webpack_public_path__ + "img/vegetable-watercress-190x100.a088dcee.jpg";